import React, { useState } from 'react';
import { styles } from './styles';
import Dropdown from './Dropdown';

const Table = ({ requests }) => {
  // State to manage dropdown and dateCompleted for each row dynamically
  const [dropdownState, setDropdownState] = useState({});
  const [dateCompletedState, setDateCompletedState] = useState({});

  // Handle dropdown toggle
  const handleStatusClick = (id) => {
    setDropdownState((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  // Handle status selection
  const handleSelectStatus = (id, status) => {
    setDropdownState((prevState) => ({
      ...prevState,
      [id]: false,
    }));
    setDateCompletedState((prevState) => ({
      ...prevState,
      [id]: status,
    }));
  };

  // Handle date change
  const handleDateChange = (id, date) => {
    setDateCompletedState((prevState) => ({
      ...prevState,
      [id]: date,
    }));
  };

  return (
    <div className="relative overflow-x-auto p-2 px-1 mt-10">
      <table className="table-auto border-collapse w-full">
        <thead>
          <tr className="border border-gray-800 border-opacity-50 text-xl font-bold" style={styles.interText}>
            <th className="py-4">Order ID</th>
            <th className="py-4">Full Name</th>
            <th className="py-4">Phone Number</th>
            <th className="py-4">Post Code</th>
            <th className="py-4">Service Type</th>
            <th className="py-4">Contact Date</th>
            <th className="py-4">Contact Time</th>
            <th className="py-4">Status</th>
            <th className="py-4">Date Completed</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((request, index) => (
            <tr key={index} className='text-lg font-normal border-b-2 border-gray-400 relative' style={styles.interText}>
              <td className="px-4 py-4 pt-10">{request.orderId}</td>
              <td className="px-4 py-4 pt-10">{request.fullName}</td>
              <td className="px-4 py-4 pt-10">{request.phoneNumber}</td>
              <td className="px-4 py-4 pt-10">{request.postCode}</td>
              <td className="px-4 py-4 pt-10">{request.serviceType}</td>
              <td className="px-4 py-4 pt-10">{request.contactDate}</td>
              <td className="px-4 py-4 pt-10">{request.contactTime}</td>
              <td className="flex px-4 py-4 pt-10 cursor-pointer" onClick={() => handleStatusClick(request.orderId)}>
                <div className='pt-3.5 mr-2'>Status {dropdownState[request.orderId] || 'Pending'}</div>
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 50 50" className='w-14 h-14'>
                  <path fill="black" d="m25 32.4l-9.7-9.7l1.4-1.4l8.3 8.3l8.3-8.3l1.4 1.4z" />
                </svg>
                {dropdownState[request.orderId] && <Dropdown onSelect={(status) => handleSelectStatus(request.orderId, status)} />}
              </td>
              <td className="px-4 py-4">
                <input 
                  type="text" 
                  value={dateCompletedState[request.orderId] || ""} 
                  onChange={(e) => handleDateChange(request.orderId, e.target.value)} 
                  placeholder="DD/MM/YYYY" 
                  className="border px-2 py-1"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
